import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useLocalStorage, useMedia } from 'react-use';
import { COMMUNITY_ROUTES } from 'configs';
import { CommunityMenu, CommunitySidebarMobile } from 'components';
import {
  CommunitySettingsPage,
  CommunityOverallSchedulerPage,
  GroupPage,
  GroupSettingsPage,
  DocumentationPage,
  // CommunityChatPage,
  EmailModulePage,
  CommunityLandingPage,
  PushNotificationPage,
  PersonalChat,
} from 'pages';
import { breakpoints } from 'theme';
import ChatFeaturePopup from 'components/Popups/ChatFeaturePopup';

const CommunityRouter = () => {
  const isWide = useMedia(breakpoints.md);
  const [chatFeatureVisible, setChatFeatureVisible] = useState<boolean>(false);

  const [lsChatFeaturePopup, setLsChatFeaturePopup] = useLocalStorage<boolean>(
    'chatFeaturePopupShown',
    false,
  );

  useEffect(() => {
    if (!lsChatFeaturePopup) {
      setLsChatFeaturePopup(true);
      setTimeout(() => setChatFeatureVisible(true), 3000);
    }
  }, [lsChatFeaturePopup]);

  return (
    <>
      <ChatFeaturePopup
        isOpen={chatFeatureVisible}
        onClose={() => setChatFeatureVisible(false)}
      />
      {isWide ? <CommunityMenu /> : <CommunitySidebarMobile />}
      <Routes>
        <Route path="*" element={<CommunityLandingPage />} />
        <Route
          path={COMMUNITY_ROUTES.SETTINGS}
          element={<CommunitySettingsPage />}
        />
        <Route
          path={COMMUNITY_ROUTES.OVERALL}
          element={<CommunityOverallSchedulerPage />}
        />
        <Route path={COMMUNITY_ROUTES.CHAT} element={<PersonalChat />} />
        {/* <Route
          path={`${COMMUNITY_ROUTES.CHAT}/:conversationId`}
          element={<PersonalChat />}
        /> */}
        <Route
          path={`${COMMUNITY_ROUTES.OVERALL}/${COMMUNITY_ROUTES.EVENT}/:eventId`}
          element={<CommunityOverallSchedulerPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.OVERALL}/${COMMUNITY_ROUTES.EVENT}/:eventId/details`}
          element={<CommunityOverallSchedulerPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.GROUP}/:groupId`}
          element={<GroupPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.GROUP}/:groupId/${COMMUNITY_ROUTES.EVENT}/:eventId`}
          element={<GroupPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.GROUP}/:groupId/${COMMUNITY_ROUTES.EVENT}/:eventId/details`}
          element={<GroupPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.GROUP}/:groupId/${COMMUNITY_ROUTES.SETTINGS}`}
          element={<GroupSettingsPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.DOCUMENTATION}/*`}
          element={<DocumentationPage />}
        />
        <Route path={COMMUNITY_ROUTES.EMAIL} element={<EmailModulePage />} />
        {/* <Route
          path={`${COMMUNITY_ROUTES.CHAT}/:chatId`}
          element={<CommunityChatPage />}
        /> */}
        <Route
          path={COMMUNITY_ROUTES.PUSH_NOTIFICATION}
          element={<PushNotificationPage />}
        />
        <Route
          path={`${COMMUNITY_ROUTES.PUSH_NOTIFICATION}/:conversationId`}
          element={<PushNotificationPage />}
        />
      </Routes>
    </>
  );
};

export default CommunityRouter;
